
import axios from 'axios';
import { Store } from '@reduxjs/toolkit';
import { readFromLocalStorage } from '../utils/DataEncryption';

const baseURL = process.env.REACT_APP_BASE_URL;
const openAPIBaseURL = process.env.REACT_APP_OPEN_API_BASE_URL;
const defaultHeaders = {
  'Content-Type': 'application/json',
};

let store: Store | null = null;

export const injectStore = (_store: Store) => {
  store = _store;
};

export const setRequestHeaders = (requestHeaders: any = {},contentType="application/json") => {
  const token = readFromLocalStorage("token");
  //  const token = "eyJ0eXAiOiJKV1QiLCJub25jZSI6InAwR2R0aVA0MlBBd3BGX211ZWVxRDhFcHJyRGtuOEo3c1JRcURRY3djUGsiLCJhbGciOiJSUzI1NiIsIng1dCI6ImtXYmthYTZxczh3c1RuQndpaU5ZT2hIYm5BdyIsImtpZCI6ImtXYmthYTZxczh3c1RuQndpaU5ZT2hIYm5BdyJ9.eyJhdWQiOiJodHRwczovL2dyYXBoLm1pY3Jvc29mdC5jb20iLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8yM2RjZDk4Yi01N2Y1LTRkZWMtOTgwMC1mM2FiMmRmZDVjNTMvIiwiaWF0IjoxNzA3OTAyMzMxLCJuYmYiOjE3MDc5MDIzMzEsImV4cCI6MTcwNzkwNjIzMSwiYWlvIjoiRTJWZ1lJZzRtUExtVlg3ZXEydS8vS3cweFZOcUFBPT0iLCJhcHBfZGlzcGxheW5hbWUiOiJUVlMgU21hcnQgU2FsZXMiLCJhcHBpZCI6ImRjYTk3NTQyLTc3MDEtNGRhZC04NGRlLTQ5YzE2MTQyMWVmNCIsImFwcGlkYWNyIjoiMSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzIzZGNkOThiLTU3ZjUtNGRlYy05ODAwLWYzYWIyZGZkNWM1My8iLCJpZHR5cCI6ImFwcCIsIm9pZCI6IjM3NDI5MmExLTc0Y2EtNDRiZC04YzRhLWYwODk3NjkwMThiMSIsInJoIjoiMC5BVDhBaTluY0lfVlg3RTJZQVBPckxmMWNVd01BQUFBQUFBQUF3QUFBQUFBQUFBQV9BQUEuIiwicm9sZXMiOlsiVXNlci5SZWFkV3JpdGUuQWxsIiwiVXNlci5FbmFibGVEaXNhYmxlQWNjb3VudC5BbGwiLCJVc2VyLlJlYWQuQWxsIiwiU2VydmljZVByaW5jaXBhbEVuZHBvaW50LlJlYWRXcml0ZS5BbGwiLCJBcHBSb2xlQXNzaWdubWVudC5SZWFkV3JpdGUuQWxsIiwiVXNlci5NYW5hZ2VJZGVudGl0aWVzLkFsbCJdLCJzdWIiOiIzNzQyOTJhMS03NGNhLTQ0YmQtOGM0YS1mMDg5NzY5MDE4YjEiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiQVMiLCJ0aWQiOiIyM2RjZDk4Yi01N2Y1LTRkZWMtOTgwMC1mM2FiMmRmZDVjNTMiLCJ1dGkiOiJWVFlrOXlvMmFVNjA3NmZoNUJJWEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyIwOTk3YTFkMC0wZDFkLTRhY2ItYjQwOC1kNWNhNzMxMjFlOTAiXSwieG1zX3RjZHQiOjE2OTc3MTEwODV9.qT97UKUCTpu7QUroJjidKn12M33GIJYGg3wrhCMzmPhg9Q5wWxERu76FYn-SxYbTE5FSRxPKcEc3q3hxsfiP03ibyygpIilglSJs45IbnUqrR_OfdObXgyAbiKZP2uSzpFZkKWyCaAKIsp93UgtqHs2LU7ehkIHCpmqEwXnJG8JvmdTnQ4Qss2WutJoZznKEuHxwgj62X7urUeqDpcfwQwatlN33zlWsQ7XJCPelOHdK9GqzMpSQzMj-GxI3y1xlhHrOWb7V4PAIsMy3CfcAOVngon5DCUUNb_yii_D8x_wmxwwSlpyg078iPY3tIQuleny3RXDqiZ7btC0SJlJS5Q";
  const headers = {
    'Content-Type': contentType,
    'authorization':`Bearer ${token}`,
    ...requestHeaders,
  };
  // If the content type is multipart/form-data, let Axios handle the content type
  if (contentType === 'multipart/form-data') {
    delete headers['Content-Type']; // Remove the Content-Type header for FormData
  } else {
    headers['Content-Type'] = contentType;
  }
  return headers;
};


const http = {
  get: async (url: string,header={},isOpenAPI=false) => {
    try {
      let requestHeaders: any = setRequestHeaders(header);
      console.log(requestHeaders,"requestHeaders");
      const response = await axios.get(`${isOpenAPI?openAPIBaseURL:baseURL}${url}`, { headers: requestHeaders });
      return response.data;
    } catch (error) {
      console.error('Error making GET request:', error);
      throw error;
    }
  },

  post: async (url: string, data: any,contentType="application/json",isOpenAPI=false) => {
    try {
      let requestHeaders: any = setRequestHeaders({},contentType);
      const response = await axios.post(`${isOpenAPI?openAPIBaseURL:baseURL}${url}`, data, { headers: requestHeaders });
      return response.data;
    } catch (error) {
      console.error('Error making POST request:', error);
      throw error;
    }
  },

  put: async (url: string, data: any,contentType="application/json") => {
    try {
      let requestHeaders: any = setRequestHeaders({},contentType);
      const response = await axios.put(`${baseURL}${url}`, data, { headers: requestHeaders });
      return response.data;
    } catch (error) {
      console.error('Error making PUT request:', error);
      throw error;
    }
  },

  delete: async (url: string) => {
    try {

      let requestHeaders = setRequestHeaders();
      const response = await axios.delete(`${baseURL}${url}`, { headers: requestHeaders });
      return response.data;
    } catch (error) {
      console.error('Error making DELETE request:', error);
      throw error;
    }
  },
};

export default http;
